<template>
  <div class="agenda">
    <div v-show="!loading">
      <div class="agenda-headers">
        <header1></header1>
        <header2 v-model="header2"></header2>
      </div>

      <div class="flex">
        <task-pool></task-pool>
        <calendar></calendar>
      </div>
      <task-modal></task-modal>
      <show-task-modal></show-task-modal>
      <project-modal></project-modal>
      <small-task-modal></small-task-modal>
      <show-project-modal></show-project-modal>
    </div>
  </div>
</template>
<script>
import Header1 from './header1'
import Header2 from './header2'
import TaskPool from './task-pool/task-pool'
import Calendar from './calendar/calendar'
import TaskModal from './task-modal/task-modal'
import ShowTaskModal from './task-modal/show-task'
import ProjectModal from './task-pool/project-modal/project-modal'
import SmallTaskModal from './small-task-modal/small-task-modal'
import ShowProjectModal from './task-pool/project-modal/show-project'

export default {
  components: {
    Header1,
    Header2,
    TaskPool,
    Calendar,
    TaskModal,
    ProjectModal,
    ShowTaskModal,
    SmallTaskModal,
    ShowProjectModal,
  },
  created() {
    this.header2.default_offset = -(moment().day() - 1)
    this.header2.offset = this.header2.default_offset
    this.load()

    this.$root.$on('Agenda::reload', () => this.load())
  },
  data() {
    return {
      header2: {
        days_to_show: 5,
        offset: 0,
        default_offset: 0,
        dates: [],
      },
      dates: [],
      loading: true,
    }
  },
  methods: {
    load() {
      let token = this.$requestManager.newRequest('agenda-user-load-request')

      this.axios.get('/users', {
        params: {
          agenda: true,
          date_offset: this.header2.offset,
          days_to_load: this.header2.days_to_show
        },
        cancelToken: token,
      }).then(res => {
        this.$root.$emit('Calendar::load-users', res.data.data)
        this.loading = false
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/agenda.vue